import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Whitepapers3() {
  const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};


const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};


const handleContactSubmit = async (e) => {
  e.preventDefault();
 
  setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;


  // Basic validation
  if (!fullname || !email || !message || !company || !phone ) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
     try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
        {showSuccessModal && (
          <motion.div
            className="modal-overlay show"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              className="modal show"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                width: "400px",
                textAlign: "center",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                Message Sent!
              </h2>
              <p>Thank you for contacting us. We will get back to you shortly.</p>
              <button className="vc rg lk gh ml il hi gi _l"
                onClick={() => setShowSuccessModal(false)}
               
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
            
            <div className="container">
               <div className="left">
          <img src="../images/wh2.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
  Amplify. Analyze. Accelerate: How Content Syndication Data Powers High-Impact B2B Leads 
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span> Oct 23, 2025
                   
                </li>
                <li  className="jutfy">
                    <span className="rc kk wm"><b>Published by:</b></span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            <p className="mk3 ij">
               Transforming syndicated content into measurable revenue growth
              </p>
             
              <p className="mb bgimh">
              Introduction
              </p>
 <p className="jutfy">
  In 2025, B2B marketing is no longer about reach — it’s about relevance. As digital ecosystems expand and buyer journeys fragment, marketers are shifting focus from volume-based outreach to intelligence-led engagement. Content syndication, once a channel for broad awareness, is now a data-rich engine for lead precision. When fueled by analytics, intent signals, and AI, content syndication data becomes a strategic asset that accelerates both pipeline velocity and marketing ROI.


=              </p>
               <p className="mb bgimh">
            Amplify: Expanding Reach with Precision
              </p>
 <p className="jutfy">

Traditional content syndication focused on distribution — ensuring whitepapers, webinars, and reports reached wider audiences. But the modern approach amplifies visibility with intent. By combining syndication platforms with real-time behavioral and firmographic data, businesses can now target high-value audiences across multiple ecosystems — industry portals, professional networks, and niche publications. This shift transforms syndication from a scattergun approach into a laser-focused amplification engine. Every impression, click, and download becomes a measurable step toward identifying active, in-market accounts.
              </p>

               <p className="mb bgimh">
               Analyze: Turning Syndication Data into Buyer Intelligence
              </p>
 <p className="jutfy">
The true power of content syndication lies in the data it generates — from content engagement rates and dwell time to topic-level interest and purchase signals. By integrating this data into CRM and marketing automation systems, marketers gain a 360° view of buyer intent and readiness. Artificial intelligence enhances this process further by detecting behavioral correlations, scoring leads dynamically, and identifying patterns that indicate purchase potential. For example, a surge in downloads around a specific solution category might signal an active buying cycle. This intelligence allows sales teams to engage with precision, prioritizing leads that are most likely to convert.               </p>
              <p className="mb bgimh">
           Accelerate: Driving Pipeline and ROI
              </p>

 <p className="jutfy">
  Once amplified and analyzed, syndication data accelerates the sales funnel. Nurturing workflows can be automated using predictive scoring, personalized follow-ups, and dynamic content sequencing based on audience behavior. This ensures that every touchpoint — from awareness to conversion — is timely, relevant, and impactful. Moreover, performance analytics help marketers measure ROI across channels. By tracking lead quality, engagement depth, and conversion velocity, marketing leaders can identify which syndication partners, content types, and audience segments deliver the strongest return on investment.
              </p>


                <p className="mb bgimh">
The Competitive Advantage in 2025

              </p>

                <p className="jutfy">
                  As third-party cookies disappear and privacy regulations tighten, first-party and syndication data emerge as reliable, compliant alternatives for audience insights. Companies leveraging data-enriched syndication strategies gain not only higher-quality leads but also faster go-to-market cycles and stronger alignment between marketing and sales. In a competitive B2B landscape, speed, precision, and personalization define success — and syndication intelligence delivers all three.
            </p>
               <p className="mb bgimh">
          Your Growth Partner in 2025 and Beyond
              </p>
              
 <p className="jutfy">
  With Pinakinedge Media, you gain more than a syndication vendor — you gain a strategic partner who helps you see the story behind every click, download, and engagement.
We help B2B marketers make smarter decisions, shorten sales cycles, and scale revenue through data-driven syndication intelligence.
              </p>
               <p className="mb bgimh">
Conclusion
              </p>
             <p className="jutfy">
              Content syndication in 2025 is no longer a top-of-funnel tactic — it’s a strategic growth driver. By amplifying content reach, analyzing audience intelligence, and accelerating conversions through data-driven automation, businesses can transform syndicated assets into measurable revenue outcomes. With the right technology, analytics, and partners, marketers can finally achieve what every B2B organization strives for: content that not only informs but converts — at scale.
              </p>
              <p className="jutfy">Let’s turn your content into your next competitive advantage</p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
              <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("White Paper2: Amplify. Analyze. Accelerate: How Content Syndication Data Powers High-Impact B2B Leads");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
 
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Whitepapers3;
